<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.arm_id}">
      <label>Select Arm:</label>
      <select :value="arm_id" name="arm_id" class="form-control" @change="handleChange">
        <option value="" />
        <option v-for="arm in config.arms" :value="arm.id">
          {{ arm.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    
    props: {
      arm_id: [String, Number],
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.isNumber(this.arm_id)) {
          this.errors.arm_id = "Please select an Arm.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
